var _g, _circle, _g2, _path, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26303_36611)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 44C20 30.7452 30.7452 20 44 20C57.2548 20 68 30.7452 68 44C68 57.2548 57.2548 68 44 68C30.7452 68 20 57.2548 20 44Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26303_36611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 48,
    height: 48
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 24,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26303_36611)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 91,
    height: 48,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26303_36611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 32,
    width: 27,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.39 38.7317C35.0986 38.7317 34.0485 39.7819 34.0485 41.0732V51.6098C34.0485 52.9011 35.0986 53.9512 36.39 53.9512H52.7802C54.0715 53.9512 55.1217 52.9011 55.1217 51.6098V41.0732C55.1217 39.7819 54.0715 38.7317 52.7802 38.7317H49.8136L47.4709 35.2195H41.7367L39.3519 38.7317H36.39ZM52.7802 56.2927H36.39C33.8073 56.2927 31.707 54.1924 31.707 51.6098V41.0732C31.707 38.4905 33.8073 36.3902 36.39 36.3902H38.1109L40.4957 32.8781H48.7236L51.0663 36.3902H52.7802C55.3628 36.3902 57.4631 38.4905 57.4631 41.0732V51.6098C57.4631 54.1924 55.3628 56.2927 52.7802 56.2927ZM44.5365 42.472C42.6809 42.472 41.1706 43.9822 41.1706 45.8378C41.1706 47.6934 42.6809 49.2037 44.5365 49.2037C46.3921 49.2037 47.9023 47.6934 47.9023 45.8378C47.9023 43.9822 46.3921 42.472 44.5365 42.472ZM44.5365 51.5451C41.3896 51.5451 38.8292 48.9847 38.8292 45.8378C38.8292 42.6909 41.3896 40.1305 44.5365 40.1305C47.6834 40.1305 50.2438 42.6909 50.2438 45.8378C50.2438 48.9847 47.6834 51.5451 44.5365 51.5451Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26303_36611)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.707,
    y: 31.7073,
    width: 26,
    height: 26,
    fill: "#6D788E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26303_36611",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.286275 0 0 0 0 0.364706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26303_36611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26303_36611",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCamera);
export default __webpack_public_path__ + "static/media/circle-camera.34b64ad3334b1d79477e1ac7cc807350.svg";
export { ForwardRef as ReactComponent };